<template>
    <div>
        <v-container fluid grid-list-xl class="home-container general-container">
            <v-layout row wrap class="navigation-header">
                <v-flex xs12>
                    <header-bar></header-bar>
                </v-flex>
            </v-layout>

            <div class="scrolling-content-products path">
                <v-layout row wrap class="page-content page-content-pf" >
                    <v-flex lg4 offset-lg4 md8 offset-md2 sm10 offset-sm1 xs12 class="no-padding-bottom no-padding-top">
                        <h2 class="page-title hidden-xs-only">PATHFINDER {{text('db.global.TYPE_GTS_WELCOME_TITLE_D')}}</h2>
                        <div class="margin-bottom-m margin-top-m hidden-xs-only">
                            <description></description>
                        </div>
                        <div class="hidden-sm-and-up">
                            <description></description>
                        </div>
                    </v-flex>
                    <v-flex md2 xs12 align-end class="activate-product" v-if="getUserData.role === 'USER'">
                        <v-btn color="primary" @click="showActivationCodePopup()" class="float-right no-margin-right text-uppercase font-weight-light" >{{text('api.button.activationcode')}}</v-btn>
                    </v-flex>
                </v-layout>

                <v-layout row wrap class="body-home padding-right-s">
                    <v-flex lg4 offset-lg4 md8 offset-md2 sm10 offset-sm1 xs12 class="home-product-list">

                        <product-list @onClickProduct="handleClickProduct"></product-list>

                    </v-flex>

                </v-layout>
            </div>
        </v-container>

        <code-popup></code-popup>
    </div>
</template>

<!-- ################################################################## -->

<script>
    import {mapActions, mapGetters} from 'vuex';
    import HeaderBar from '../../shared/HeaderBar';
    import chooseProductSvg from "../../../../common/components/svg/productList/chooseProduct";
    import CodePopup from '../../../../common/components/shared/ActivationCodePopup';
    import ProductList from '../../shared/ProductList';
    import Description from '../../shared/Description';

    export default {
        name: 'HomePage',
        components: {
            HeaderBar,
            chooseProductSvg,
            CodePopup,
            ProductList,
            Description
        },

        beforeCreate() {
            // Reset stores.
            this.$store.commit('PfProductListStore/resetStore');
            this.$store.commit('PfAssessmentStartStore/resetStore');
            this.$store.commit('ChooseMainSymptomStore/resetStore');
            this.$store.commit('PfSymptomsQuestionsStore/resetStore');
            this.$store.commit('EvaluationStore/resetStore');
            this.$store.commit('ScoringStore/resetStore');
            this.$store.commit('SummaryStore/resetStore');
            this.$store.commit('AssessmentAlertsStore/resetStore');

            sessionStorage.setItem('smass-home-route', "PF_HomePage"); // This will help us to know HOME menu button destination.
        },

        created () {
            // Load product list data from server.
            this.$store.dispatch('PfProductListStore/loadProductListPageData');
        },

        computed: mapGetters({
            products: 'PfProductListStore/getProductList',
            getUserData: 'UserStore/getUserData'
        }),

        methods: {
            ...mapActions({
                showActivationCodePopup: 'ProductListStore/showActivationCodePopup'
            }),
            // Component methods.
            handleClickProduct (productCode) {
                this.$store.dispatch('PfProductListStore/selectProduct', productCode).then(() => {
                    this.$router.push('start-questions');
                });
            },
            hideTestPopup() {
                this.$store.commit('ProductListStore/setMustShowActivationCodePopup', false);
            }
        },

        data () {
            return {
                items: [
                    {
                        src: 'static/img/in4medicine_logo.svg',
                        title: 'in4medicine',
                        description: 'Medizin und Informatik - ein starkes Team.'
                    }
                ]
            }
        }
    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>

    .home-container.container.grid-list-xl {

        .body-home {

            margin-bottom: -60px;

            .product_icon {
                width: 30px;
            }
        }
    }

    .product-list {

        li, .product-item {
            border-radius: 5px;
        }
    }

    .container.grid-list-xl .activate-product{

        button {
            text-transform: none;
            @include border-radius(4px);

        }
    }

    .btn-start-assessment {
        border-color: $color-element-outline;
    }

    .icon-start-assessment {
        font-size: 36px;
    }

    .sponsors {
        border-radius: 5px;
    }

   .scrolling-content-products.path {
       overflow: hidden;
   }

    @media only screen and (max-width: 600px) {

        .page-content.page-content-pf {
            margin-top: 0 !important;
        }

    }

</style>



// WEBPACK FOOTER //
// src/pathfinder/components/standard-forms/home/HomePage.vue